import React, { useContext, useEffect } from "react";

/* plugin */
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "react-toastify";
import { toasterConfig } from "../utils/Constant";
/* plugin end */

/* service */
import AuthContext from "../store/auth-context";
import gs from "../services/global";
/* service end */

const LoanCalComp = () => {
  const authCtx = useContext(AuthContext);

  /* animation */
  const [parent] = useAutoAnimate();
  /* animation end */

  /* fetch product once to populate paymentData (monthly payment) */
  useEffect(() => {
    const offerName = authCtx?.offerData?.name;
    const amount = authCtx?.amountSlideValue;
    const periodMonth = authCtx?.periodSlideValueMonth;

    if (!offerName || amount == null || periodMonth == null) return;

    gs.showLoader(true);
    const productBaseUrl = `/offer/product?offerId=${offerName}&amount=${amount}&duration=${periodMonth}`;
    const productPostLink = authCtx?.productUrl
      ? `${productBaseUrl}${authCtx.productUrl}`
      : productBaseUrl;

    axios
      .get(productPostLink)
      .then((response) => {
        const result = response?.data;
        authCtx.paymentDataFunc(result);
        if (result?.error) {
          const errorText = `${result?.error}, please change the value for Loan amount and Period.`;
          toast.error(errorText, toasterConfig);
        }
        gs.showLoader(false);
      })
      .catch(() => {
        gs.showLoader(false);
      });
  }, [
    authCtx?.offerData?.name,
    authCtx?.amountSlideValue,
    authCtx?.periodSlideValueMonth,
  ]);

  return (
    <motion.div
      initial={{ y: 60, scale: 0.9, opacity: 0 }}
      animate={{ y: 0, scale: 1, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="comm-box wel-loan" ref={parent}>
        <div className="card-main-amt">
          <div className="card-amt-flex">
            <div className="card-amt">
              <h6>Loan amount</h6>
              {authCtx?.amountSlideValue && (
                <p>£{authCtx?.amountSlideValue}</p>
              )}
            </div>
            <div className="card-amt">
              <h6>Period</h6>
              {authCtx?.periodSlideValue && (
                <p>{authCtx?.periodSlideValue} months</p>
              )}
            </div>
            <div className="card-amt">
              <h6>Estimated payment</h6>
              {authCtx?.paymentData?.installmentAmount && (
                <p>
                  £
                  {Number(authCtx?.paymentData?.installmentAmount).toFixed(2)}{" "}
                  /mo
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="comm-disclaim mb0">
          <p>
            Amount of credit £2000 over 36 months. Interest £921.12. Interest rate (nominal) 26.3% pa (fixed). Repay with 36 instalments of £81.39. Total amount payable £2921.12. Representative APR: 29.7%
          </p>
          <p>
            <b>Warning</b>: Late repayment can cause you serious money
            problems. For help, go to{" "}
            <a
              href="https://www.moneyhelper.org.uk/"
              target="_blank"
              rel="noreferrer"
            >
              moneyhelper.org.uk
            </a>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default LoanCalComp;
